module.exports = __webpack_public_path__ + "assets/media/clock.67430018.svg";